<template>
    <b-modal
        id="add-magazine-modal"
        v-model="modal"
        ref="add-magazine-modal"
        :title="$t('magazine.add_new_title')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="saveMagazine"
        modal-class="apprentice-default-modal">
        <div class="new-magazine">
            <b-form>
                <b-form-group
                    label="Type:"
                    label-for="type_id">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="type_id"
                        required>
                        <option value="2">{{ $t('yearbook.yearbook') }}</option>
                        <option value="1">{{ $t('yearbook.magazine') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.type_id"
                        >{{ allerrors.type_id[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('common.title') + ':'"
                    label-for="title">
                    <b-form-input
                        v-model="title"
                        :placeholder="$t('common.title')"
                        required>
                    </b-form-input>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.title"
                        >{{ allerrors.title[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.active_for_print') + ':'"
                    label-for="activeforprint">
                    {{ $t('magazine.active_for_print_explanation') }}
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="activeforprint"
                        required>
                        <option value="1">{{ $t('common.yes') }}</option>
                        <option value="0">{{ $t('common.no') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.show_all_pages"
                        >{{ allerrors.show_all_pages[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    label="CJP actie:"
                    label-for="cjpPromotinal">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="cjpPromotional"
                        required>
                        <option value="1">{{ $t('common.yes') }}</option>
                        <option value="0">{{ $t('common.no') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.show_all_pages"
                        >{{ allerrors.show_all_pages[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.format') + ':'"
                    label-for="size_id">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="size_id"
                        required>
                        <option
                            v-for="size in sizes"
                            :value="size.id">
                            {{ size.title }} {{ size.width }}mm x {{ size.height }}mm
                        </option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.size_id"
                        >{{ allerrors.size_id[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.amount_of_pages') + ':'"
                    label-for="num_pages">
                    <b-form-input
                        v-model="num_pages"
                        type="number"
                        required>
                    </b-form-input>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.num_pages"
                        >{{ allerrors.num_pages[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.amount_of_copies') + ':'"
                    label-for="quantity">
                    <b-form-input
                        v-model="quantity"
                        type="number"
                        required>
                    </b-form-input>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.quantity"
                        >{{ allerrors.quantity[0] }}</label
                    >
                </b-form-group>

                <div class="vertical-margin">
                    <b-form-group
                        :label="$t('magazine.margin_left') + ':'"
                        label-for="margin_left">
                        <b-form-input
                            v-model="margin_left"
                            type="number"
                            required>
                        </b-form-input>
                        <label
                            class="error mt-2 text-danger"
                            v-if="allerrors.margin_left"
                            >{{ allerrors.margin_left[0] }}</label
                        >
                    </b-form-group>
                    <b-form-group
                        :label="$t('magazine.margin_right') + ':'"
                        label-for="margin_right">
                        <b-form-input
                            v-model="margin_right"
                            type="number"
                            required>
                        </b-form-input>
                        <label
                            class="error mt-2 text-danger"
                            v-if="allerrors.margin_right"
                            >{{ allerrors.margin_right[0] }}</label
                        >
                    </b-form-group>
                </div>

                <div class="horizontal-margin">
                    <b-form-group
                        :label="$t('magazine.margin_top') + ':'"
                        label-for="margin_top">
                        <b-form-input
                            v-model="margin_top"
                            type="number"
                            required>
                        </b-form-input>
                        <label
                            class="error mt-2 text-danger"
                            v-if="allerrors.margin_top"
                            >{{ allerrors.margin_top[0] }}</label
                        >
                    </b-form-group>
                    <b-form-group
                        :label="$t('magazine.margin_bottom') + ':'"
                        label-for="margin_bottom">
                        <b-form-input
                            v-model="margin_bottom"
                            type="number"
                            required>
                        </b-form-input>
                        <label
                            class="error mt-2 text-danger"
                            v-if="allerrors.margin_bottom"
                            >{{ allerrors.margin_bottom[0] }}</label
                        >
                    </b-form-group>
                </div>

                <b-form-group
                    :label="$t('magazine.show_all_pages') + ':'"
                    label-for="show_all_pages">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="show_all_pages"
                        required>
                        <option value="1">{{ $t('common.yes') }}</option>
                        <option value="0">{{ $t('common.no') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.show_all_pages"
                        >{{ allerrors.show_all_pages[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.own_templates_images') + ':'"
                    label-for="own_templates">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="own_templates"
                        required>
                        <option value="1">{{ $t('common.yes') }}</option>
                        <option value="0">{{ $t('common.no') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.own_templates"
                        >{{ allerrors.own_templates[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.format_type') + ':'"
                    label-for="version">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="version"
                        required>
                        <option value="garenloos">{{ $t('magazine.format_types.threadless') }}</option>
                        <option value="hardbound">{{ $t('magazine.format_types.hardbound') }}</option>
                        <option value="wire-o">{{ $t('magazine.format_types.wire_o') }}</option>
                        <option value="geniet">{{ $t('magazine.format_types.enjoy') }}</option>
                        <option value="digitaal">{{ $t('magazine.format_types.digital') }}</option>
                        <option value="gevouwen">{{ $t('magazine.format_types.folded') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.version"
                        >{{ allerrors.version[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    label="Laminering:"
                    label-for="lamination">
                    <div v-if="laminationError">
                        <b-alert
                            show
                            variant="danger"
                            >{{ $t('magazine.lamination_mandatory') }}
                        </b-alert>
                    </div>
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="lamination"
                        required>
                        <option value="glans">{{ $t('magazine.lamination_type.glossy') }}</option>
                        <option value="mat">{{ $t('magazine.lamination_type.matt') }}</option>
                        <option value="stof">{{ $t('magazine.lamination_type.fabric') }}</option>
                        <option value="leer">{{ $t('magazine.lamination_type.leather') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.lamination"
                        >{{ allerrors.lamination[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.create_the_cover_entirely') + ':'"
                    label-for="full-cover-optin-select">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="full_cover">
                        <option :value="1">{{ $t('common.yes') }}</option>
                        <option :value="0">{{ $t('common.no') }}</option>
                    </b-form-select>
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.printer') + ':'"
                    label-for="printer">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="printer"
                        required>
                        <option value="GIGAPRINT">GIGAPRINT</option>
                        <option value="VELDHUIS">VELDHUIS</option>
                        <option value="IPSKAMP">IPSKAMP</option>
                        <option value="BOOKADEW">BOOKADEW</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.printer"
                        >{{ allerrors.printer[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.paper') + ':'"
                    label-for="paper">
                    <b-form-select
                        class="apprentice-primary-select"
                        v-model="paper"
                        required>
                        <option value="120G_MC_DCP">120G_MC_DCP (Gigaprint)</option>
                        <option value="MATMC">MATMC</option>
                        <option value="SILK">SILK</option>
                        <option value="GLOSSMC">GLOSSMC</option>
                        <option
                            value="135 grams hv silk mc binnenwerk, 300 grams eenzijdig gestreken sulfaatkarton omslag">
                            {{ $t('magazine.paper_type.135_gram_silk_mc_inside_300_gram_sulfate_cardboard_cover') }}
                        </option>
                        <option value="SRA3 gloss 150">SRA3 gloss 150</option>
                        <option value="Uitzondering">{{ $t('magazine.paper_type.exception_see_comments') }}</option>
                    </b-form-select>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.paper"
                        >{{ allerrors.paper[0] }}</label
                    >
                </b-form-group>

                <b-form-group
                    :label="$t('magazine.comments') + ':'"
                    label-for="remarks">
                    <b-form-textarea
                        class="apprentice-textarea"
                        v-model="remarks"
                        :placeholder="$t('magazine.comments')"
                        rows="5"></b-form-textarea>
                    <label
                        class="error mt-2 text-danger"
                        v-if="allerrors.remarks"
                        >{{ allerrors.remarks[0] }}</label
                    >
                </b-form-group>
            </b-form>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-add-magazine-modal-component',
    props: {
        sizes: {
            type: Array,
        },
    },
    data() {
        return {
            modal: false,
            activeforprint: 1,
            cjpPromotional: 0,
            type_id: 2,
            title: '',
            size_id: 1,
            num_pages: 24,
            quantity: 1,
            show_all_pages: 1,
            own_templates: 0,
            version: 'garenloos',
            lamination: 'glans',
            printer: '',
            paper: '',
            remarks: '',
            margin_top: 15,
            margin_right: 15,
            margin_bottom: 15,
            margin_left: 15,
            full_cover: 1,
            allerrors: [],
            laminationError: false,
        };
    },
    methods: {
        show() {
            this.type_id = 2;
            this.title = '';
            this.size_id = 1;
            this.num_pages = 24;
            this.quantity = 1;
            this.margin_left = 15;
            this.margin_right = 15;
            this.margin_top = 15;
            this.margin_bottom = 15;
            this.show_all_pages = 1;
            this.own_templates = 0;
            this.version = 'garenloos';
            this.lamination = 'glans';
            this.printer = 'GIGAPRINT';
            this.paper = '120G_MC_DCP';
            this.remarks = '';
            this.activeforprint = 1;
            this.cjpPromotional = 0;
            this.modal = true;
        },

        saveMagazine(e) {
            this.laminationError = !this.lamination;

            if (!this.laminationError) {
                let data = {
                    activeforprint: this.activeforprint,
                    cjp_promotional: this.cjpPromotional,
                    type_id: this.type_id,
                    title: this.title,
                    size_id: this.size_id,
                    num_pages: this.num_pages,
                    quantity: this.quantity,
                    show_all_pages: this.show_all_pages,
                    own_templates: this.own_templates,
                    version: this.version,
                    lamination: this.lamination,
                    printer: this.printer,
                    paper: this.paper,
                    remarks: this.remarks,
                    margin_top: this.margin_top,
                    margin_right: this.margin_right,
                    margin_bottom: this.margin_bottom,
                    margin_left: this.margin_left,
                    full_cover: this.full_cover,
                };
                this.alert.saving();

                this.axios
                    .post('/magazine/save', data)
                    .then((response) => {
                        this.$emit('add-magazine', response.data.magazine);
                    })
                    .catch((error) => {
                        if (error.response) {
                            this.alert.close();
                            this.allerrors = error.response.data.errors;
                        } else {
                            this.alert.ajaxError(error);
                        }
                    });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.new-magazine {
    select {
        margin-bottom: 0;
    }

    .vertical-margin,
    .horizontal-margin {
        display: flex;
        justify-content: space-between;

        .form-group {
            width: calc(50% - 15px);
        }
    }
}
</style>
